import dayjs from 'dayjs'
import route from '@/utils/route'
import lib from '@/components/lib/index'
import * as util from '@/utils/util'
dayjs.locale('zh-cn')

export default {
    dayjs,
    route,
    ...util,
    ...lib
}